import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useObrasState } from "./context/obras-context";
import { useObrasController } from "./context/obras-controller";
import { ObrasTable } from "./obrasTable.component";

export function ObrasPage() {
  const { obras, obraPagedRequest, loading, situacoes, funcoes, tipos, ultimaAtualizacao, error } = useObrasState();
  const { onInit, handleOnChange, listObras, exportObras } = useObrasController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listObras({ ...obraPagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Obras" },
        ]}
      />
      <PageTitle>Obras</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Tipo de Obra</InputLabel>
                  <Select
                    name="select-tipo-id"
                    value={obraPagedRequest?.idTipoObra || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Tipo de Obra"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {tipos?.map((t) => (
                      <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Função</InputLabel>
                  <Select
                    name="select-funcao-id"
                    value={obraPagedRequest?.idFuncaoObra || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Função"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {funcoes?.map((f) => (
                      <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Situação</InputLabel>
                  <Select
                    name="select-situacao-id"
                    value={obraPagedRequest?.idSituacaoObra || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Situação"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {situacoes?.map((s) => (
                      <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={obraPagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SearchButton onClick={() => (async () => {
                  await listObras(obraPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportObras} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <ObrasTable currentItems={obras} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={obras?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
